import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VEHICLE_WIZARD_SAMPLE } from "../consts";
import { VehicleWizardSceneProps } from "../types";

/** Korak "Slike": galerija s naslovnom slikom, prijenos fotografija i gdje se slike koriste. */
const PicturesScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  const pictures = vehicleInfo.pictureUrls.length > 0 ? vehicleInfo.pictureUrls : VEHICLE_WIZARD_SAMPLE.pictures;
  const [cover, ...rest] = pictures;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-3">
          <div className="relative h-[11.2rem] rounded-md bg-gradient-to-br from-amber-200 to-amber-300 overflow-hidden">
            <img src={cover} alt="" className="absolute inset-0 w-full h-full p-[10px] object-contain" />
            <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-white/90 text-[0.6rem] font-semibold text-slate-700">
              Naslovna
            </span>
          </div>
          <div className="mt-2 grid grid-cols-3 gap-2">
            {rest.slice(0, 3).map((picture, index) => (
              <div key={index} className="h-14 rounded-md bg-slate-100 overflow-hidden">
                <img src={picture} alt="" className="w-full h-full object-contain" />
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-slate-800">Prijenos slika</span>
            <span className="text-[0.65rem] font-semibold text-blue-600">3 / 4</span>
          </div>
          <div className="mt-3 flex items-center justify-center h-16 rounded-md border-2 border-dashed border-blue-200 bg-blue-50/50">
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 16V4M7 9l5-5 5 5M4 20h16" />
            </svg>
          </div>
          <div className="mt-3 h-1.5 rounded-full bg-slate-100">
            <div className="h-full w-3/4 rounded-full bg-gradient-to-r from-blue-500 to-sky-400" />
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Slike idu u oglas"
          subtitle="Naslovna ide prva na portale"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <path d="M21 15l-5-5L5 21" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(PicturesScene);
